import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Input, Modal, message } from 'antd';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';

import Wrapper, { ModelWrapper } from './style';
import { ExclamationCircleFilled, ExclamationCircleOutlined } from '@ant-design/icons';
import { putExchange, getExchange } from '../../common/fetch';
import { ExchangeAction } from '../../actions';
import { checkUpgrade } from '../../common/utils';
import { defaultRepo, defalutBranch, YOUTUBE_CHANNEL_LINK } from '../../config/constants';
import { CUSTOM_EDIT_COLOR, CUSTOM_EDIT_EXCHANGE, CUSTOM_EXCHANGE_VIDEO, CUSTOMIZE_TOP_ICON, GIT_ICON, EDIT_ICON } from '../../config/media';
import { RenderTodo } from '../PluginList/TodoConfirmation';
import Carousel from '../../components/Carousel'
import ExchangeTerminateMessage from '../../common/exchangeTerminate'

class CustomizeSection extends Component {
    constructor() {
        super()
        this.state = {
            isVisible: false,
            type: 'customize-confirm',
            repo: {},
            isDisable: false,
            isConfirmed: false,
            isMobile: false
        }
    }
    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }
    componentWillUnmount() {
        window.removeEventListener('resize', () => { })
    }
    handleResize = (e) => {
        const { innerWidth } = window;
        const { isMobile } = this.state;

        if (innerWidth <= 960 && !isMobile) {
            this.setState({ isMobile: true });
        } else if (innerWidth > 960 && isMobile) {
            this.setState({ isMobile: false })
        }
    };
    handleUpgrade = () => {
        this.props.history.push('/billing');
    }
    toggleVisibility = () => {
        const { isVisible, type } = this.state;
        this.setState({ isVisible: !isVisible })

        if (type === 'customize-repo' && isVisible === true) {
            this.setState({ type: 'customize-confirm' })
        }
    }
    getExchange = async () => {
        try {
            const res = await getExchange();
            const exchange = res.data.data.sort((a, b) => {
                const ad = new Date(a.updated_at);
                const bd = new Date(a.updated_at);
                if (Math.floor(ad - bd) >= 0) {
                    return a - b;
                } else {
                    return b - a;
                }
            });
            this.props.storeExchange(exchange);
        } catch (error) {
            if (error && error.data) {
                message.error(error.data.message)
            }
        }
    };
    putExchange = async (isDisable) => {
        const { exchange } = this.props;
        try {
            let params = {
                id: exchange.id,
                info: {
                    repository: {
                        url: isDisable ? defaultRepo : this.state.repo.url,
                        branch: isDisable ? defalutBranch : this.state.repo.branch
                    }
                }
            }
            await putExchange(params);
            await this.getExchange();
            const link = document.createElement('a');
            if (!isDisable) {
                link.href = 'https://github.com/apps/hollacloud/installations/new';
            }
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.error(error);
        }
    };
    handleTextChange = (e) => {
        this.setState({
            repo: {
                ...this.state.repo,
                [e.target.name]: e.target.value
            }
        });
    };

    handleConnect = (type) => {
        if (type === "confirm-disable") {
            this.putExchange(true);
            this.setState({ isVisible: false });
        } else {
            this.setState({ isDisable: true });
            this.putExchange();
        }
    }

    handleDisable = () => {
        this.setState({ type: 'disable-content', isVisible: true });
    }

    handleInput = (e) => {
        if (e.target.value === "I UNDERSTAND") {
            this.setState({ isConfirmed: true })
        } else {
            this.setState({ isConfirmed: false })
        }
    }

    renderPopupContent = () => {
        const { biz, exchange } = this.props;
        switch (this.state.type) {
            case 'customize-confirm':
            default:
                return (
                    <ModelWrapper>
                        <div>
                            <div className="title">
                                Customize repo
                            </div>
                            <div className="warning-wrapper">
                                <ExclamationCircleFilled className="warning-icon" />
                                Before your proceed it is important to note that this may have unknown effects on your exchange.
                            </div>
                            <div className='git-icon'>
                                <img src={GIT_ICON} alt={'GIT_ICON'} />
                            </div>
                            <div className="content-wrapper">
                                If you want to customize your exchange you can point your own git repo through this wizard.
                            </div>
                            <div className="content-wrapper">Are you sure you want to continue?</div>
                            <div className="btn-wrapper">
                                <Button type="primary" onClick={this.toggleVisibility}>Back</Button>
                                <div className="divider"></div>
                                <Button
                                    type="primary"
                                    // href="https://github.com/apps/bitholla-testnet/installations/new"
                                    onClick={() => this.setState({ type: 'customize-repo' })}
                                >
                                    Next
                                </Button>
                            </div>
                        </div>
                    </ModelWrapper>
                );
            case 'customize-repo':
                return (
                    <ModelWrapper>
                        <div>
                            <div className="title">
                                Customize repo
                            </div>
                            <div className="content-wrapper">Repo URL should contain a protocol (https), and should end with '.git'</div>
                            <div className="content-wrapper">
                                <div className="content-title">Repo URL</div>
                                <Input
                                    name="url"
                                    placeholder={defaultRepo}
                                    onChange={this.handleTextChange}
                                    defaultValue=""
                                    value={this.state.repo.url}
                                />
                            </div>
                            <div className="content-wrapper">
                                <div className="content-title">Repo branch</div>
                                <Input
                                    name="branch"
                                    placeholder={defalutBranch}
                                    onChange={this.handleTextChange}
                                    defaultValue=""
                                    value={this.state.repo.branch}
                                />
                            </div>
                            <div className="btn-wrapper">
                                <Button type="primary" onClick={() => this.setState({ type: 'customize-confirm' })}>Back</Button>
                                <div className="divider"></div>
                                <Button
                                    type="primary"
                                    disabled={!this.state.repo.url || !this.state.repo.branch}
                                    onClick={this.handleConnect}
                                >
                                    Connect
                                </Button>
                            </div>
                        </div>
                    </ModelWrapper>
                );
            case 'disable-content':
                return (
                    <ModelWrapper>
                        <div className="title">
                            Reset repo to default
                        </div>
                        <div>Resetting will revert the GitHub to the default <span className="content-title">HollaEx Kit.</span></div>
                        <div>This may have drastic effects on your exchange.</div>
                        <div className="description-box">
                            <div>
                                <span className="header description-header">Reset to</span>
                            </div>
                            <div>
                                <span className="content-title">Repo URL:</span><span>{' '}{defaultRepo}</span>
                            </div>
                            <div>
                                <span className="content-title">Custom repo branch:</span>{' '}<span>{defalutBranch}</span>
                            </div>
                        </div>
                        <div>
                            <div>
                                Type 'I UNDERSTAND' to confirm
                            </div>
                            <div className="divider" />
                            <div>
                                <Input onChange={this.handleInput} />
                            </div>
                        </div>
                        <div className="btn-wrapper">
                            <Button type="primary" onClick={() => this.setState({ isVisible: false })}>Back</Button>
                            <div className="divider"></div>
                            <Button disabled={!this.state.isConfirmed}
                                type="primary"
                                onClick={() => this.handleConnect("confirm-disable")}
                            >
                                I understand. proceed
                            </Button>
                        </div>
                    </ModelWrapper>
                );
            case 'going-live':
                return (
                    <ModelWrapper>
                        <div className="non-live-wrapper">
                            <div className="description">
                                <img
                                    src={EDIT_ICON}
                                    alt="going-live"
                                    className="list-icon"
                                />
                            </div>
                            <div className="list-title">Customize and edit your exchange</div>
                            <div className="description">
                                To customize your exchange you must login to your exchange as an admin and click the direct edit tab at the bottom left of your screen.
                            </div>
                            <div className="description exchange-link">
                                <b>Domain currently set:</b>{' '}
                                <a href={biz.DOMAIN} target="_blank" rel="noopener noreferrer">
                                    {biz.DOMAIN}
                                </a>
                            </div>
                            <div>
                                <Button type='primary' className="back-btn" onClick={() => this.setState({ isVisible: false })}>Back</Button>
                            </div>
                        </div>
                    </ModelWrapper>
                );
            case 'not-live':
                return <RenderTodo
                    exchange={exchange}
                    handleClose={this.toggleVisibility}
                />
        }
    };

    handleCardClick = ({ name }) => {
        const { exchange } = this.props;

        if (name === 'EXCHANGE_VIDEO') {
            window.open(YOUTUBE_CHANNEL_LINK);
        } else if ((name === 'EDIT_COLOR' || name === 'EDIT_EXCHANGE')) {
            if (!exchange.is_running || !exchange.is_paid) {
                this.setState({ type: 'not-live', isVisible: true });
            } else {
                this.setState({ type: 'going-live', isVisible: true });
            }
        }
    };

    render() {
        const { isMobile } = this.state;
        const responsive = {
            0: { items: 1 },
            568: { items: 2 },
            960: { items: 3 },
        };
        const { exchange } = this.props;
        const repository = exchange.info && exchange.info.repository
            ? exchange.info.repository
            : {};
        const isUpgrade = checkUpgrade(exchange);
        const cards = [
            { name: 'EXCHANGE_VIDEO', icon: CUSTOM_EXCHANGE_VIDEO },
            { name: 'EDIT_COLOR', icon: CUSTOM_EDIT_COLOR },
            { name: 'EDIT_EXCHANGE', icon: CUSTOM_EDIT_EXCHANGE },
        ]
        return (
            <Wrapper>
                <div className="main-header">Customize</div>
                <div className={`content ${this.props.constant.isExchangeExpired ? "expired-status" : ""}`}>
                    <div className="flex-center box">
                        <div className='image-container'>
                            <img src={CUSTOMIZE_TOP_ICON} alt="CUSTOMIZE_TOP_ICON" />
                        </div>
                        <div className="divider" />
                        <div>
                            <div className="small-title">CUSTOM TOOLS</div>
                            <div className="sub-title">Customize your exchange</div>
                            <div>
                                Change strings, icons, add languages to customize your exchange in real-time. Add your own GitHub repo and code your exchange.
                            </div>
                        </div>
                    </div>
                    <div>
                        {!isMobile ?
                            <div className="card-container flex-center">
                                {cards.map((card, index) => {
                                    return <div
                                        key={index}
                                        className="card"
                                        style={{ backgroundImage: `url(${card.icon})` }}
                                        onClick={() => this.handleCardClick(card)}
                                    />
                                })
                                }
                            </div>
                            :
                            <Carousel
                                responsive={responsive}
                                items={cards.map((card, index) => {
                                    return <img
                                        key={index}
                                        alt="plugin-card"
                                        src={card.icon}
                                        className="mobile-card"
                                        onClick={() => this.handleCardClick(card)}
                                    />
                                })}
                            />
                        }
                    </div>
                    <div className="sub-content">
                        <div className="sub-title">Custom coins</div>
                        <div>Add your coin in the <Link to="/financial">Assets section</Link></div>
                    </div>
                    <div className="border-bottom" />
                    <div className="sub-content">
                        <div className="sub-title">Customize your domain</div>
                        <div>Add your own{' '}
                            <Link to={exchange.type === 'Cloud' ? "/hosting?tab=1" : "/general"}>custom domain URL</Link>
                        </div>
                    </div>
                    <div className="border-bottom" />
                    <div className="sub-content">
                        <div className="sub-title">Apply your design</div>
                        <div>Design and create your own theme with these {' '}
                            <a href={"https://docsend.com/view/qz9dsxd6xgtjjcbd"}>pro tips</a>
                        </div>
                    </div>
                    <div className="border-bottom" />
                    {/* <div className="sub-content">
                        <div className="sub-title">See what others are doing</div>
                        <div>View other custom made exchanges on the <Link to="/project">public projects page</Link></div>
                    </div> */}
                    <div className="content-divider" />
                    <div className="divider" />
                    <div className="advanced-title">Advanced</div>
                    <div className='sub-content'>
                        <div className="sub-title">Custom kit GitHub repo</div>
                        <div>A GitHub repo will allow you to connect your custom HollaEx Kit repository to your cloud exchange.</div>
                        <div>Apply your own custom GitHub repo and code your own cloud exchange.</div>
                    </div>
                    {exchange.type === "Cloud"
                        ?
                        <div>
                            {isUpgrade || !exchange.is_paid
                                ?
                                <div className="upgrade-section">
                                    <div className='customize-txt-wrapper'>
                                        <div className="customize-txt">Fully customize your platform</div>
                                        <div>Get more control over your platform.</div>
                                    </div>
                                    <div className="btn-wrapper">
                                        <Button type="primary" onClick={this.handleUpgrade}>Upgrade Now</Button>
                                    </div>
                                </div>
                                : null
                            }
                            <div className={isUpgrade || !exchange.is_paid ? "block-ui-container blocked-ui" : "block-ui-container"}>
                                {isUpgrade || !exchange.is_paid
                                    ?
                                    <div className="block-ui-message">
                                        <ExclamationCircleOutlined />
                                        <div onClick={this.handleUpgrade}>
                                            <span className="anchor">Upgrade</span> to access this section.
                                        </div>
                                    </div>
                                    : null
                                }
                                <div>
                                    <span className="list-head">Current repo:</span>{' '}
                                    <span>
                                        {repository.url
                                            ? repository.url
                                            : 'Default'
                                        }
                                    </span>
                                </div>
                                <div>
                                    <span className="list-head">Custom repo branch:</span>{' '}
                                    <span>
                                        {repository.branch
                                            ? repository.branch
                                            : 'Default'
                                        }
                                    </span>
                                </div>
                                <div className="button-wrapper">
                                    <div className="customize-btn">
                                        <Button
                                            onClick={() => this.setState({
                                                isVisible: true,
                                                type: 'customize-confirm',
                                                repo: {
                                                    url: repository.url ? repository.url : '',
                                                    branch: repository.branch ? repository.branch : ''
                                                }
                                            })}
                                            type="primary"
                                        >
                                            Configure
                                        </Button>
                                    </div>
                                    <div className="divider" />
                                    {repository.url && repository.url !== defaultRepo
                                        ? <Button type="danger" className="reset-btn" onClick={this.handleDisable}>Reset</Button>
                                        : null
                                    }
                                </div>
                                <div>
                                    If you haven't given proper repo permission you can view{' '}
                                    <a target="blank" href="https://docs.hollaex.com/">how-to here.</a>
                                </div>
                                {repository.url && repository.url !== defaultRepo
                                    ?
                                    <div className="disable-info">
                                        To apply the new HollaEx Kit to your current exchange, please go to the <Link to="/hosting?tab=2"> Hosting section</Link> and click apply upgrade / rebuild button.
                                    </div>
                                    : null
                                }
                            </div>
                        </div>
                        :
                        <div className="DIY-info">This feature is for cloud exchanges</div>
                    }
                </div>
                {this.props.constant.isExchangeExpired && <ExchangeTerminateMessage />}
                <Modal
                    visible={this.state.isVisible}
                    onCancel={this.toggleVisibility}
                    footer={null}
                    width={450}
                >
                    {this.renderPopupContent()}
                </Modal>
            </Wrapper>
        );
    }
}

const mapStateToProps = (state) => ({
    exchange: state.exchange && state.exchange.length ? state.exchange[0] : {},
    biz: state.biz,
    constant: state.constant,
});
const mapDispatchToProps = (dispatch) => ({
    storeExchange: bindActionCreators(ExchangeAction.readData, dispatch),

});
export default connect(mapStateToProps, mapDispatchToProps)(CustomizeSection);